// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Grid,
  FormControl,
  Glyphicon
} from "react-bootstrap";
import { withRouter } from "react-router-dom";
import {
  submit,
  hasSubmitSucceeded,
  getFormSyncErrors,
  touch
} from "redux-form";
import currencySymbols from "../../../utils/currencySymbols";
import "./styles.css";

class Proceed extends Component<void> {
  constructor(props) {
    super(props);
    this.state = { value: "" };
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.continueText.show &&
      nextProps.submitSucceeded &&
      nextProps.confirmedBooking
    ) {
      this.props.history.push("/payment"); 
    } else if (
      !nextProps.continueText.show &&
      nextProps.submitSucceeded &&
      !nextProps.confirmedBooking
    ) {
      this.props.history.push("/complete");
    }
     localStorage.setItem("cnbk", this.props.confirmedBooking ? "true" : "false");

  }

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  applyPoints = () => {
    this.props.updateNotification(this.props.id, "pointsApplied", true);
  };

  removePoints = () => {
    this.props.updateNotification(this.props.id, "pointsApplied", false);
  };

  applyCode = () => {
    this.props.updateNotification(this.props.id, "promoCode", this.state.value);
  };

  submitForm = () => {
    this.props.submit("terms");
  };

  render() {
    let CustomerMessage = "";
    let ShowPointsButtons = true;

    if (this.props.customer && this.props.customer.pointsValue) {
      CustomerMessage =
        "As an existing customer you have " +
        currencySymbols[this.props.money.currency[0]] +
        (this.props.customer.pointsValue / 100).toFixed(2) +
        " of loyalty points";

      if (this.props.customer.pointsValue < 1) {
        ShowPointsButtons = false;
      }
    } else {
      CustomerMessage =
        "You do not have existing loyalty points with Ski-Lifts";
      ShowPointsButtons = false;
    }

    return (
      <Grid>
        <Col xs={12} className="proceed-box">
          <Col className="info" >
            <Col xs={12}>
              <Button
                bsStyle="success"
                bsSize="large"
                type="submit"
                style={{ width: "100%", marginBottom: "15px" }}
                onClick={this.submitForm}
              ><span>
                {this.props.confirmedBooking
                  ? "Proceed to Payment"
                  : "Make Request"}
                  </span>
              </Button>
            </Col>
            <Col xs={12} >
              <div className="info-btn-group">
                <Col >
                  <FormControl
                    value={this.state.value}
                    placeholder="Enter Code"
                    onChange={this.handleChange}
                    type="text"
                    
                  />
                </Col>
                <Col >
                  {!this.props.promoCode ? (
                    <Button
                      bsStyle="primary"
                      onClick={this.applyCode}
                    ><span>
                      Apply Code</span>
                    </Button>
                  ) : (
                    <Button
                      bsStyle="success"
                      onClick={this.applyCode}
                    >
                      <Glyphicon style={{ marginRight: "5px" }} glyph="ok" /><span>Code
                      Applied</span>
                    </Button>
                  )}
                </Col>
              </div>
            </Col>
          </Col>
          <Col className="info points">
            <Col xs={12} className="text-center">
              <strong>
                <h3>Existing customer loyalty points</h3>
              </strong>
              <h5 style={{ color: "#666" }} className="proceed-text">
                {CustomerMessage}
              </h5>
            </Col>
            <Col
              xs={12}
              className={
                ShowPointsButtons ? "text-center" : "text-center hidden"
              }
            >
              <Col xs={12} sm={6}>
                <Button
                  bsStyle="primary"
                  style={{ width: "100%" }}
                  onClick={this.applyPoints}
                >
                  Apply Points
                </Button>
              </Col>
              <Col xs={12} sm={6}>
                <Button
                  bsStyle="default"
                  style={{ width: "100%", color: "rgb(38, 88, 134)" }}
                  onClick={this.removePoints}
                  className="doNotApply"
                >
                  Do Not Apply Points
                </Button>
              </Col>
            </Col>
          </Col>
        </Col>
      </Grid>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      submitErrors: getFormSyncErrors("terms")(state),
      submitSucceeded: hasSubmitSucceeded("terms")(state),
      continueText: state.basket.data.continueText,
      confirmedBooking: state.basket.data.confirmedBooking
    }),
    { submit, touch }
  )(Proceed)
);



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/Proceed/index.js